module.exports = __webpack_public_path__ + "static/media/corner-red.1a0a2469.svg";